// @import dependencies
import React, { CSSProperties, useState } from 'react'
import { useForm } from 'react-hook-form'
import { useTranslation } from 'react-i18next'
// @end dependencies

// @import components
// @end components

// @import types
// @end types

// @import components
import ReactSelectComponent from 'app_components/commons/reactSelect'
// @end components

// @import services
// @end services

// @import hooks
// @end hooks

// @import actions
// @end actions

// @import utils
// @end utils

// @import assets
// @end assets

// @import styles
import './ReprogramingForm.scss'
// @end styles

interface IReprogramingFormProps {
  className?: string
  style?: CSSProperties
  id?: string
  onHandleSubmit?: (data: any) => void,
}

const ReprogramingForm: React.FC<IReprogramingFormProps> = (props) => {

  const { t } = useTranslation()

  const formHook = useForm()

  const [listOfReasons] = useState<Array<any>>([
    {value: 'client', label: 'Solicitud del cliente'},
    {value: 'account_executive', label: 'Ejecutivo de cuenta'},
    {value: 'internal', label: 'Operaciones Icontec'},
  ])

  const handleSubmit = (data: any) => {
    if (props.onHandleSubmit) {
      props.onHandleSubmit(data)
    }
  }

  return(
    <div
      className={`reprograming_form-layout ${props.className ? props.className : ''}`}
      style={props.style}
      id={props.id}
    >
      <form onSubmit={formHook.handleSubmit(handleSubmit)}>
        <div className="row">
          <div className="col-md-12">
            <div className="form-group">
              <label htmlFor='reason'>{t('modules.reprogramingForm.reason')}</label>
              <ReactSelectComponent
                identifier='reason'
                options={listOfReasons}
                formHooks={formHook}
                defaultValue={[]}
                isMulti={false}
                required={true}
              />
              {formHook.errors.reason && <div className='custom-invalid-feedback'>{t('errors.this_field_is_required')}</div>}
            </div>
          </div>
          <div className="col-12">
            <button className='btn btn-primary' type='submit' >
              {t('buttons.save')}
            </button>
          </div>
        </div>
      </form>
    </div>
  );
}
export default ReprogramingForm;
